import React from "react";
import "./../../NaliSalonPage/NailSalonTestimonial/NailSalonTestimonial.css";
import NailSalonTestimonialHead from "../../NaliSalonPage/NailSalonTestimonial/NailSalonTestimonialHead";
import FacialTestimonialsMain from "./FacialTestimonialsMain";
const FacialTestimonials = () => {
  return (
    <div className="nailTestimonialContainer">
      <NailSalonTestimonialHead para="" />
      <FacialTestimonialsMain />
    </div>
  );
};

export default FacialTestimonials;
